import { string } from 'yup';
import { ValidationConfigSE } from '@/src/lib/validation/validation.config';
import { RegisterFormValidationModel } from '@/src/lib/validation/models/register-form-validation.model';
import { getZipCodeMessage, getMaxLengthMessage } from '@/src/lib/dictionary/utils';

export class RegisterFormValidationModelSE extends RegisterFormValidationModel {
  public get zipCode() {
    const fieldName = this.DICT.userProfile.userData.postcode;
    const maxLength = ValidationConfigSE.ZIP_MAX_LENGTH;

    return string()
      .required(this.REQUIRED_MESSAGE)
      .matches(ValidationConfigSE.ZIP_REGEX, getZipCodeMessage(this.DICT, this.TENANT_CONFIG.zipCodeExample.default))
      .length(ValidationConfigSE.ZIP_MAX_LENGTH, getMaxLengthMessage(fieldName, maxLength, this.DICT))
      .trim();
  }
}
